"use strict";
const componentClasses = {
    TEMPLATE_WRAPPER: 'template-wrapper',
    TEXT_COMPONENT: 'text-component-container',
    TEXT_TARGET_DIV: 'target-div',
    BUTTON_COMPONENT: 'tot-button-component',
    IMAGE_COMPONENT: 'tot-image-component',
    VIDEO_BEAT_COMPONENT: 'tot-video-beat-component',
    SOCIAL_ICONS_COMPONENT: 'social-icons-component',
    DIVIDER_COMPONENT: 'tot-divider-component',
    TR_COMPONENT: 'tr-component',
    NPS_TABLE_CONTAINER: 'nps-table-container',
    MEDIA_QUERY_CLASS: 'with-media-queries',
    FOOTER_COMPONENT: 'tot-footer-component',
    STATIC_TD: 'static-td',
    STATIC_ANCHOR: 'static-anchor',
    NPS_COMPONENT: 'nps-component',
    CSAT_COMPONENT: 'csat-component',
    OLD_TEMPLATES_FOOTER: ['template-footer', 'plain-text-company-details'],
    SECTION_ROW: 'section-row',
    TABLE_SECTION_CELL: 'table-section-data-cell',
    BODY_WRAPPER: 'template-body-wrapper',
    WATERMARK: 'watermark-link',
};
const componentTypes = {
    SECTION_WRAPPER: 'section-wrapper',
    MAIN_WRAPPER: 'template-wrapper',
    MAIN_BODY: 'body-wrapper-component',
    SECTION: 'section',
    USAGE_CARD: 'usage-card',
    destinationPageInfoField: 'destination-page-info-field',
    FOOTER: 'footer',
    SIGNATURE: 'signature',
    DISMISS_BUTTON: 'dismiss-button',
    TEXT_COMPONENT: 'rich-text',
    IMAGE_COMPONENT: 'totango-image',
    STATIC_IMAGE: 'static-image',
};
const booleanAttributeValues = {
    ON: 'on',
    OFF: 'off',
};
const componentAttributes = {
    BODY_WIDTH: 'data-body-width',
    SHOW_FOOTER: 'show-footer',
    USE_COMPANY_FOOTER: 'use-company-footer',
    USE_COMPANY_LOGO: 'use-company-logo',
    VIDEO_BEAT_DATA: 'video-beat-data',
};
const withMediaQueriesClass = 'with-media-queries';
const mobileCss = `
@media screen and (max-device-width: 575px), screen and (max-width: 575px) {
	.${withMediaQueriesClass} .${componentTypes.SECTION_WRAPPER} {
		display: none;
	}
	
	.${withMediaQueriesClass} .${componentClasses.TABLE_SECTION_CELL} {
		display: block;
		width: 100% !important;
		padding-right: 0 !important;
		padding-left: 0 !important;
	}
	.${withMediaQueriesClass} .nps-btn-td {
		display: block;
		width: 90% !important;
		height: 40px !important;
		margin: auto auto 8px;
	}
	.${withMediaQueriesClass} .nps-btn-td .nps-btn-content{
		height: 40px;
		width: 100% !important;
	}
	.${withMediaQueriesClass} .nps-table-container {
		width: 100% !important;
		direction: ltr !important;
	}
	.${withMediaQueriesClass} .nps-table-text-container {
		display: none;
	}
	.${withMediaQueriesClass} .nps-mobile-text {
		display: inline-block !important;
	}
	.${withMediaQueriesClass} .csat-table-container {
		width: 100% !important;
	}
	.${withMediaQueriesClass} .csat-btn {
		width: 43px !important;
		height: 40px !important;;
	}
	.${withMediaQueriesClass} .${componentClasses.FOOTER_COMPONENT} img {
		max-width: 100% !important;
		height: auto !important;;
	}
	.${withMediaQueriesClass} .${componentTypes.USAGE_CARD} .icon-option {
		display: none;
	}
	.${withMediaQueriesClass} .${componentTypes.USAGE_CARD}[card-view-option="horizontal"] .display-text,
	.${withMediaQueriesClass} .${componentTypes.USAGE_CARD}[card-view-option="horizontal"] .aggregation-label,
	.${withMediaQueriesClass} .${componentTypes.USAGE_CARD}[card-view-option="horizontal"] .field-value {
		display: block;
		display: flex;
		justify-content: center;
	}
	.${withMediaQueriesClass} .${componentTypes.USAGE_CARD}[card-view-option="horizontal"] .display-text-wrapper {
		display: block;
	}
}
`;
const buildCompanyStyleClass = (baseClass) => `${baseClass}.with-company-style`;
const buildButtonStyle = (buttonTheme) => `
	background-color: ${buttonTheme.bgColor} !important;
	border: ${buttonTheme.border} !important;
	border-radius: ${buttonTheme.borderRadius} !important;
`;
const buildButtonTextStyle = (theme, buttonTheme = {}) => `
		color: ${buttonTheme.fontColor} !important;
		font-family: ${theme.fontFamily} !important;
		font-size: ${buttonTheme.fontSize} !important;
`;
const getThemeStyle = (theme) => `
	.${buildCompanyStyleClass(componentClasses.TEMPLATE_WRAPPER)}:not([data-body-plain-text='on']) {
        background-color: ${theme.bgColor} !important;
    }
    .${componentClasses.BUTTON_COMPONENT}.variant-primary .${componentClasses.BUTTON_COMPONENT}-box {
        ${buildButtonStyle(theme.primaryButton)};
    }
    .${componentClasses.BUTTON_COMPONENT}.variant-primary .link-content span {
        ${buildButtonTextStyle(theme, theme.primaryButton)};
    }
    .${componentClasses.SECTION_ROW}[background-option="company"] .${componentClasses.TABLE_SECTION_CELL} {
		background-color: ${theme.color} !important;
	}
    .${componentClasses.BUTTON_COMPONENT}.variant-secondary .${componentClasses.BUTTON_COMPONENT}-box {
        ${buildButtonStyle(theme.secondaryButton)};
    }
    .${componentClasses.BUTTON_COMPONENT}.variant-secondary .link-content span {
        ${buildButtonTextStyle(theme, theme.secondaryButton)};
    }
    .${buildCompanyStyleClass(componentClasses.DIVIDER_COMPONENT)} .divider-line {
        border-bottom-color: ${theme.color} !important;
    }
    .${buildCompanyStyleClass(componentClasses.SOCIAL_ICONS_COMPONENT)} a:not([social-in-footer='on']) {
        background-color: ${theme.color} !important;
    }
`;
const CAMPAIGN_SCHEDULE_TYPES = {
    IMMEDIATELY: 'immediately',
    LATER: 'later',
    ONGOING: 'ongoing',
    RECURRING: 'recurring',
};
const CHANNEL_TYPE = {
    EMAIL: 'email',
    SUNCO: 'sunco',
};
const CAMPAIGN_TEMPLATES_STATIC_LIST = [
    { templateId: 'newFeatureIntroduction', name: 'Introduction of New Feature Campaign' },
    { templateId: 'newUserOnBoarding', name: 'Onboard New Users Campaign' },
    { templateId: 'training', name: 'Feature Training/Education Campaign' },
    { templateId: 'nps', name: 'NPS Survey' },
    { templateId: 'csat', name: 'Customer Satisfaction Survey' },
    { templateId: 'usageReflection', name: 'SuccessBeat' },
    { templateId: 'buildYourOwnCampaign', name: 'Custom' },
];
module.exports = {
    componentClasses,
    componentAttributes,
    booleanAttributeValues,
    mobileCss,
    getThemeStyle,
    CAMPAIGN_SCHEDULE_TYPES,
    CHANNEL_TYPE,
    CAMPAIGN_TEMPLATES_STATIC_LIST,
};
//# sourceMappingURL=consts.js.map